export const blogPosts = [
  {
    id: 1,
    slug: "10-ways-get-cheap-car-hire-perth",
    title: "10 Ways to Get Cheap Car Hire in Perth",
    summary:
      "10 ways to get cheap car hire in Perth with Tak8 Car Rental. From booking early to loyalty perks, enjoy budget-friendly rates and stress-free rentals.",
    image:
      "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    category: "tips",
    date: "March 15, 2024",
    readTime: 8,
    featured: true,
  },
  {
    id: 2,
    slug: "7-common-car-hire-mistakes-avoid",
    title: "7 Common Car Hire Mistakes and How to Avoid Them",
    summary:
      "Avoid costly mistakes when renting a car in Perth. Learn 7 key tips to book smart, drive stress-free, and save with Tak8 car hire.",
    image:
      "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    category: "tips",
    date: "March 12, 2024",
    readTime: 12,
    featured: true,
  },
  {
    id: 3,
    slug: "top-5-perth-day-trips-rental-car",
    title: "Top 5 Perth Day Trips by Rental Car",
    summary:
      "Explore the best day trip destinations from Perth with your rental car. From Rottnest Island to Swan Valley, discover amazing places within easy reach of the city.",
    image:
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    category: "travel",
    date: "March 10, 2024",
    readTime: 15,
    featured: true,
  },
  {
    id: 4,
    slug: "top-5-scenic-road-trips-perth-car",
    title: "Top 5 Scenic Road Trips from Perth by Car",
    summary:
      "Discover 5 epic scenic road trips from Perth. Explore WA's coastlines, forests, and deserts with Tak8 car rental's flexible long-term hire options.",
    image:
      "https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    category: "travel",
    date: "March 8, 2024",
    readTime: 12,
    featured: false,
  },
  {
    id: 5,
    slug: "long-term-car-hire-perth-benefits-money-saving-tips",
    title: "Long Term Car Hire in Perth: Benefits and Money-Saving Tips",
    summary:
      "Discover the advantages of long-term car rental in Perth and learn money-saving strategies for extended stays. Perfect for business travelers, tourists, and temporary residents.",
    image:
      "https://images.unsplash.com/photo-1592853625511-ad0edcc69c07?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    category: "tips",
    date: "March 18, 2024",
    readTime: 10,
    featured: true,
  },
];
